import Vue from 'vue';

/**
 * Interface assincrona para o próximo tick do Vue.
 */
export function vueNextTick() {
  return new Promise((resolve) => {
    Vue.nextTick(() => {
      resolve();
    });
  });
}

/**
 * Interface assincrona para setTimeout.
 */
export function asyncDelay(delay = 0) {
  return new Promise(resolve => setTimeout(resolve, delay));
}
